import * as Sentry from "@sentry/react";

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

export function initSentry() {
  if (!SENTRY_DSN) {
    console.warn("[Sentry] REACT_APP_SENTRY_DSN not set — monitoring disabled");
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV || "production",

    // Performance: sample 20% of transactions in prod, 100% in dev
    tracesSampleRate: process.env.NODE_ENV === "production" ? 0.2 : 1.0,

    // Session replay: capture 10% normally, 100% on errors
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],

    // Don't send PII by default
    sendDefaultPii: false,

    // Filter out noisy errors
    beforeSend(event) {
      // Ignore ResizeObserver errors (browser noise)
      if (event.exception?.values?.[0]?.value?.includes("ResizeObserver")) {
        return null;
      }
      return event;
    },
  });
}

export { Sentry };
